import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './AsideBuilderContacts.css';

interface IAsideBuilderContactsProps {
  actionButton: React.JSX.Element;
  messageButton: React.JSX.Element;
  workTimeInfo: React.JSX.Element;
  buttonsInSeparateRows: boolean;
}

export const AsideBuilderContacts: React.FC<IAsideBuilderContactsProps> = ({
  actionButton,
  messageButton,
  workTimeInfo,
  buttonsInSeparateRows,
}) => {
  return (
    <div className={styles['aside-builders-contacts']}>
      <div className={clsx(styles['buttons'], { [styles['buttons-in-separate-row']]: buttonsInSeparateRows })}>
        <div className={styles['action-button']}>{actionButton}</div>
        <div className={styles['message-button']}>{messageButton}</div>
      </div>
      {workTimeInfo}
    </div>
  );
};
